import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
  }
})

export default {
  [types.SET_INEP] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.inep = payload
  },
  [types.SET_INEPS] (state, payload) {
    state.ineps = payload.data
    state.pagination = payload.meta.pagination
  }
}
